/*
 * <eagle-stock-status>: swaps the stock tag (blocks/eagle-stock-status.liquid)
 * when the shopper changes variant. Horizon re-renders the section for the new
 * variant and hands the HTML to every listener on the productSelect event; this
 * takes its own block's markup from it, the way assets/product-inventory.js
 * does for Horizon's inventory block.
 */
import { morph } from '@theme/morph';
import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

class EagleStockStatus extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.closest('.shopify-section, dialog')?.addEventListener(StandardEvents.productSelect, this.#onProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.closest('.shopify-section, dialog')?.removeEventListener(StandardEvents.productSelect, this.#onProductSelect);
  }

  #onProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;
        if (detail.newProduct) {
          this.dataset.productId = detail.newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const next = detail.html.querySelector(`eagle-stock-status[data-block-id="${this.dataset.blockId}"]`);
        if (next) morph(this, next, { childrenOnly: true });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[eagle-stock-status] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('eagle-stock-status')) {
  customElements.define('eagle-stock-status', EagleStockStatus);
}
